import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';

import $ from 'jquery';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';
import DatePicker from 'react-datepicker';
import { logDOM } from '@testing-library/react';


function NewEnquiry() {
    const navigate = useNavigate();
    //const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    //const [userRight, setUserRight] = useState([]);

    const [entityType, setEntityType] = useState("A");

    const [reqBran, setReqBran] = useState("0");
    const [ddReqBranOptions, setDdReqBranOptions] = useState([]);
    const [reqBranSelect, setReqBranSelect] = useState({ label: 'Select', value: '0' });

    const [reqName, setReqName] = useState("");
    const [reqMobile, setReqMobile] = useState("");
    const [reqLoanAcctNo, setReqLoanAcctNo] = useState("");

    const [reqIsd, setReqIsd] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [reqIsdSelect, setReqIsdSelect] = useState([]);

    const [reqQuantity, setReqQuantity] = useState("");
    const [reqEmailAdd, setReqEmailAdd] = useState("");
    const [reqAddress, setReqAddress] = useState("");
    const [reqSellRate, setReqSellRate] = useState(0);

    const [disbursementDate, setDisbursementDate] = useState(new Date());
    const [disbursementAmt, setDisbursementAmt] = useState(0);
    const [forexAmt, setForexAmt] = useState(0);

    const [reqAgentLocation, setReqAgentLocation] = useState("0");
    const [ddReqAgentLocationOptions, setDdReqAgentLocationOptions] = useState([]);

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqAgentName, setReqAgentName] = useState("");

    const [reqSourceOfFund, setReqSourceOfFund] = useState("S");

    const [reqRemark, setReqRemark] = useState("");

    const [reqBenCountry, setReqBenCountry] = useState("0");
    const [ddReqBenCountryOptions, setDdReqBenCountryOptions] = useState([]);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'NEWENQUIRY'], function (result) {
                let resp = JSON.parse(result);
                if (resp.add === "1") {
                    // setUserRight(resp);
                    setEntityType(sessionStorage.entityType);
                    Common.callApi(Common.apiUser, [sid, 'branchallactiveselect'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqBranOptions(resp);
                    });
                    Common.callApi(Common.apiIsd, [sid, 'ddlistjsonselect'], function (result) {
                        setDdReqIsdOptions(JSON.parse(result));
                    });

                    if (sessionStorage.entityType === "A") {
                        setDdReqAgentOptions([{ label: sessionStorage.entityname, value: sessionStorage.entityId }]);
                        onChangeAgent(sessionStorage.entityId, sessionStorage.entityname);
                    }
                    if (sessionStorage.entityType === "B") {
                        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                            let resp = JSON.parse(result);
                            console.log(resp);
                            setDdReqAgentOptions(resp);
                        });
                    }
                    Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result) {
                        setDdReqBenCountryOptions(JSON.parse(result));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });

            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, entityType]);

    function handleReqBranchOptions(v) {
        setReqBranSelect(v);
        setReqBran(v.value);
    }

    function handleReqIsdOptions(v) {
        setReqIsdSelect(v);
        setReqIsd(v.value);
    }

    function resetForm() {
        setReqName("");
        setReqLoanAcctNo("");
        setReqBran("0");
        setReqBranSelect("{label: 'Select', value: '0'}");
        setReqMobile("");
        setReqEmailAdd('');
        setReqAddress('');
        setReqIsd("0");
        setReqIsdSelect("{label: 'Select', value: '0'}");
        setReqQuantity("");
        setReqSellRate("");
        setDisbursementDate(new Date());
        setDisbursementAmt("0");
        setForexAmt("0");
    }

    function onClickSubmit() {
        $('.loader').show();
        var isOk = 0;
        var msg = [], i = 0;
        if (!reqName || !reqMobile || !reqEmailAdd || !reqLoanAcctNo || reqBranSelect.value == '0' || reqAgent == '0'
            || (setDdReqAgentLocationOptions.length > 1 && reqAgentLocation === "0")


        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqAgent == '0' ? " Agent " : '');
            msg[i++] = (!reqName ? " Name " : '');
            msg[i++] = (!reqMobile ? " Mobile " : '');
            msg[i++] = (!reqEmailAdd ? " Email " : '');
            msg[i++] = (!reqLoanAcctNo ? (reqSourceOfFund === "S" ? "Unique Number" : "Loan Acct No") : '');
            msg[i++] = (reqBranSelect.value == '0' ? "Zenith Location " : '');
            msg[i++] = ((ddReqAgentLocationOptions.length > 1 && reqAgentLocation === "0") ? reqAgentName + " Location" : '')

            //msg[i++] = (reqLoanAcctNo === "0" ? " Loan Accoutn No " : '');
            isOk = 1;
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (reqMobile.length !== 10) {
            isOk = 1;
            setMsgText('Mobile No. length should be 10 digit');
            $('.loader').hide();
            setMsgBox(true);
        }


        if (isOk === 0) {
            var object1 = {
                reqBran: reqBran,
                reqName: reqName,
                reqMobile: reqMobile,
                reqLoanAcctNo: reqLoanAcctNo,
                reqIsd: reqIsd,
                reqQty: (reqQuantity.trim() === "" ? 0 : reqQuantity),
                reqEmailAdd: reqEmailAdd,
                reqAddress: reqAddress,
                reqSellRate: (reqSellRate === "" ? 0 : reqSellRate),
                reqDisbursementDate: Common.dateYMD(disbursementDate),
                reqDisbursementAmt: (disbursementAmt === "" ? 0 : disbursementAmt),
                reqForexAmt: (forexAmt === "" ? 0 : forexAmt),
                reqAgentLocation: reqAgentLocation,
                reqAgent: reqAgent,
                reqSourceOfFund: reqSourceOfFund,
                reqBenCountry: reqBenCountry,
                reqRemark: reqRemark
            }
            console.log(object1);
            Common.callApi(Common.apiEnquiry, [sid, 'save', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    resetForm();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setReqRemark("");
            });
        }
    }

    function onChangeAgent(id, agnname) {
        setReqAgent(id);
        setReqAgentName(agnname);
        setReqAgentLocation("0");
        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', id], function (result) {
            setDdReqAgentLocationOptions(JSON.parse(result));
        });
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid>
                <Row>
                    <Col>
                        <h1>Lead Details</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqAgent}
                                onChange={(e) => onChangeAgent(e.target.value, e.target[e.target.selectedIndex].text)}
                                disabled={entityType === 'A'} >
                                {ddReqAgentOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.label}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        {
                            reqAgent * 1 > 0 ? <>
                                <Form.Group>
                                    <Form.Label>Agent Location</Form.Label>
                                    <Form.Select
                                        value={reqAgentLocation}
                                        onChange={(e) => setReqAgentLocation(e.target.value)} >
                                        {ddReqAgentLocationOptions.map((res) =>
                                            <option key={res.value} value={res.value}>{res.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </> : null
                        }
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Source of Fund{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                            <Form.Select
                                value={reqSourceOfFund}
                                onChange={(e) => setReqSourceOfFund(e.target.value)}
                            >
                                <option value="S">Self</option>
                                <option value="L">Loan</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group >
                            <Form.Label>Name<span className="mandatory">*</span></Form.Label>
                            <Form.Control
                                type="text" placeholder="Name" maxLength={50} autoComplete="off"
                                value={reqName}
                                onChange={(e) => setReqName(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>{reqSourceOfFund === "S" ? "Unique Number" : "Loan Acct No"}<span className="mandatory">*</span></Form.Label>
                            <Form.Control
                                type="text" placeholder={reqSourceOfFund === "S" ? "Unique Number" : "Loan Acct No"} maxLength={50} autoComplete="off"
                                value={reqLoanAcctNo}
                                onChange={(e) => setReqLoanAcctNo(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Zenith Location<span className="mandatory">*</span></Form.Label>
                            <Select
                                value={reqBranSelect}
                                onChange={handleReqBranchOptions}
                                options={ddReqBranOptions}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group >
                            <Form.Label>Mobile No<span className="mandatory">*</span></Form.Label>
                            <Form.Control
                                type="text" placeholder="Mobile Number" maxLength={10} autoComplete="off"
                                value={reqMobile}
                                onChange={(e) => Common.validateNumValue(e.target.value, setReqMobile)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Email Id<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Control
                                type="text" placeholder="Email" maxLength={100} autoComplete="off"
                                value={reqEmailAdd}
                                onChange={(e) => setReqEmailAdd(e.target.value)}
                                onBlur={(e) => Common.validtateEmail(e.target.value, setReqEmailAdd)}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                                type="text" placeholder="Address" maxLength={255} autoComplete="off"
                                value={reqAddress}
                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setReqAddress)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group >
                            <Form.Label>Beneficiary Country</Form.Label>
                            <Form.Select
                                value={reqBenCountry}
                                onChange={(e) => setReqBenCountry(e.target.value)}  >
                                {ddReqBenCountryOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Currency</Form.Label>
                            <Select
                                value={reqIsdSelect}
                                onChange={handleReqIsdOptions}
                                options={ddReqIsdOptions}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group >
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                value={reqQuantity} autoComplete="off"

                            />
                        </Form.Group>
                    </Col>
                    {
                        /*
                            <Col>
                                <Form.Group >
                                    <Form.Label>Sale Rate</Form.Label>
                                    <Form.Control type="text" placeholder="Sale Rate" maxLength={10} autoComplete="off"
                                        value={reqSellRate}
                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqSellRate)}
                                    />
                                </Form.Group>
                            </Col>
                        */
                    }


                </Row>
                {
                    reqSourceOfFund === 'L' ?
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Disbursement Date</Form.Label>
                                    <DatePicker className="form-control"
                                        selected={disbursementDate}
                                        onChange={(date) => setDisbursementDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Disbursement Amount</Form.Label>
                                    <Form.Control
                                        type="text" placeholder="Disbursement Amount" maxLength={50} autoComplete="off"
                                        value={disbursementAmt}
                                        onChange={(e) => Common.validateNumValue(e.target.value, setDisbursementAmt)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Loan Forex Amount</Form.Label>
                                    <Form.Control
                                        type="text" placeholder="Forex Amount" maxLength={50} autoComplete="off"
                                        value={forexAmt}
                                        onChange={(e) => Common.validateNumValue(e.target.value, setForexAmt)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row> : null
                }
                <Row>
                    <Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>Remark</Form.Label>
                                <Form.Control as="textarea" rows={1} placeholder="Remark" maxLength={99} autoComplete="off"
                                    value={reqRemark}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemark)}
                                />
                            </Form.Group>
                        </Col>
                    </Col>
                </Row>

                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>

                    <Col>
                        <Button variant="outline-success" size="sm" onClick={(e) => onClickSubmit()}>Submit</Button>&nbsp;
                    </Col>
                    <Col>&nbsp;</Col>
                    <Col>&nbsp;</Col>
                    <Col>&nbsp;</Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>

            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}
export default NewEnquiry;